@if (state == "loading") {
  <div class="open-audit">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Opening audit...</p>
  </div>
} @else {
  <div class="open-audit">
    <mat-icon class="open-audit-icon">info_outline</mat-icon>
    @switch (state) {
      @case ("denied") {
        <h2>You don't have access to this audit</h2>
        <p>
          This audit template belongs to another user and hasn't been shared
          with you. Ask its owner to share it with you in AuditHub.
        </p>
      }
      @case ("notfound") {
        <h2>This audit is no longer available</h2>
        <p>
          The audit template linked from RegHub couldn't be found. It may have
          been deleted.
        </p>
      }
      @case ("archived") {
        <h2>This audit has been archived</h2>
        <p>Restore it from Archived audits to open it.</p>
      }
      @case ("upgrading") {
        <h2>This audit is being updated</h2>
        <p>Please try again in a few minutes.</p>
      }
      @case ("disabled") {
        <h2>This audit can't be opened</h2>
        <p>
          The content in this template is no longer part of your subscription.
        </p>
      }
      @default {
        <h2>Something went wrong</h2>
        <p>We couldn't open this audit. Please try again later.</p>
      }
    }
    <a mat-raised-button color="primary" routerLink="/audithub/apptool/list"
      >Go to my audits</a
    >
  </div>
}
